export default {
	URL: 'https://api-cerelus.infinitum-ti.com',
	API_URL: 'https://api-cerelus.infinitum-ti.com/api',
	OAPI_URL: 'https://api-cerelus.infinitum-ti.com/oapi',
	// URL: 'http://localhost:8989',
	// API_URL: 'http://localhost:8989/api',
	// OAPI_URL: 'http://localhost:8989/oapi',
}
